import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../utils';
// constant
import { FORM_REFS } from '../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
//action Creator
import { hideActionButton } from '../../layouts/actions/actionCreator';
import { updateCase } from '../../createAcase/actions/actionCreator';
import { blockUi, unBlockUi } from '../../../actions/actionCreator';

class CreateNewAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    let apiURL = "/aemData/formData/json_add-account";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("create-", "edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
        this.setState({ formJson: data });
      });
  }

  componentDidMount() {
    this.props.hideActionButton();
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiUrl) => {
    this.props.blockUi();
    const caseId = this.state.formData.accountHolder ? (this.state.formData.accountHolder.value) : undefined;
    var requestData = { ...this.state.formData };
    requestData.caseId = caseId;
    if (this.props.mode === 'edit') {
      apiUrl = apiUrl + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(apiUrl, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        var { caseId } = data.responseData;
        this.props.updateCase(caseId, 'accounts', Object.assign({}, this.state.formData, { id: data.responseData.id }));
        // this.props.history.push("/create-a-case/add-account");
        this.props.history.goBack();
        this.props.unBlockUi();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    if (this.props.currentAccount !== undefined) {
      formData = { ...this.props.currentAccount };
    } else {
      formData = {};
    }
    const properties = {
      accountId: this.props.match.params.accountId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'add-account-to-case',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          pageJson={this.state.formJson}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}


const mapStateToProps = (state, props) => {
  let currentAccount = undefined
  if (props.match.params) {
    var { caseId, accountId } = props.match.params;
    if (caseId && accountId && state.cases[caseId] && state.cases[caseId]['accounts'][accountId]) {
      currentAccount = state.cases[caseId]['accounts'][accountId]
    }
  }
  return {
    currentAccount,
    mode: currentAccount !== undefined ? 'edit' : '',
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CreateNewAccount.js